import { connect } from 'react-redux';

import { googleDataSelectors } from 'wanderu-ducks-google';
import {
    filterActions,
    filterSelectors,
    searchSelectors,
    tripSelectors,
} from 'wanderu-ducks-search';

import StationMap from './StationMap';

const mapDispatchToProps = {
    resetArrivalStations: filterActions.resetArriveStations,
    resetDepartureStations: filterActions.resetDepartStations,
    setArrivalStationOnlyActive: filterActions.setArriveStationOnlyActive,
    setDepartureStationOnlyActive: filterActions.setDepartStationOnlyActive,
};

function mapStateToProps(state, ownProps) {
    const { direction } = ownProps;
    const searchParams = searchSelectors.selectReduxSearchParams(state, direction);
    const {
        originPlaceId,
        destinationPlaceId,
    } = searchParams;

    const { latitude: departLat, longitude: departLng } = googleDataSelectors.selectLatLongData(
        state,
        originPlaceId,
    );

    const { latitude: arriveLat, longitude: arriveLng } = googleDataSelectors.selectLatLongData(
        state,
        destinationPlaceId,
    );

    return {
        arriveLocation: {
            lat: arriveLat,
            lng: arriveLng,
        },
        departLocation: {
            lat: departLat,
            lng: departLng,
        },
        isArrivalStationsFiltered: filterSelectors.selectArriveStationsIsFiltered(state),
        isDepartureStationsFiltered: filterSelectors.selectDepartStationsIsFiltered(state),
        searchParams,
        trips: tripSelectors.selectFilteredAndSortedTrips(state, searchParams),
    };
}

export {
    mapStateToProps,
};
export default connect(mapStateToProps, mapDispatchToProps)(StationMap);
